import { useDrop } from 'react-dnd';
import cx from 'classnames';
import { GridYValue, GridYUnit } from '../../constants';

// Where on the canvas a component from the sidebar was let go of: the top-left
// corner of the component being dragged, in pixels from the top-left corner of
// the canvas. Both are measured against the window, so the page scroll cancels
// out. Without either there is nothing to measure, and the field is added below
// the rest of the form as before.
export const getDropPoint = (sourceOffset, areaRect) => {
  if (!sourceOffset || !areaRect?.width) {
    return null;
  }

  return {
    x: sourceOffset.x - areaRect.left,
    y: sourceOffset.y - areaRect.top,
    areaWidth: areaRect.width,
  };
};

export const FormAreaContainer = ({ ...props }) => {
  const [, drop] = useDrop(() => ({
    accept: 'addFromElement',
    drop: (item, monitor) => ({
      name: 'AddNew',
      dropPoint: getDropPoint(
        monitor.getSourceClientOffset() ?? monitor.getClientOffset(),
        props.formAreaRef?.current?.getBoundingClientRect(),
      ),
    }),
  }));

  return (
    <div className="form-area-container" ref={drop}>
      <div className="form-area grid-background" ref={props.formAreaRef} style={{ height: props.formAreaHeight + GridYUnit }}>
        {props.children}
      </div>
    </div>
  );
};
